export const EVENT_ACTIONS = {
    QuestionSubmitted: "question submitted",
    MenuForListMenuClicked: "menu for question list clicked",
    AutoResponseReceived: "automated response received",
    AutoResponseAccepted: "automated response accepted",
    AutoResponseRejected: "automated response rejected",
    NewQuestionAsked: "new question asked",
    ReadMore: "read more clicked",
    MaximizedViewDisplayed: "maximized view displayed",
    Minimized: "widget minimized",
    CulDeSacAutoResponseReceived: "cul-de-sac automated response received",
    CulDeSacSessionClosed: "cul-de-sac session closed",
    SelectTask: "select task",
    AnswerLater: "answer question later",
    RemoveFromAnswerLater: "remove question from answer later",
    AddAnswer: "add answer to question",
    DismissTask: "dismiss task",
};

export const EVENT_CATEGORIES = {
    RTM: "rtm",
    EXPERT_DESKTOP: "expert desktop",
    EXPERT_MOBILE: "expert mobile",
};

export const EVENT_TRACKER = {
    EXPERT: "expertTracker",
    RTM: "rtmTracker",
};

export default {
    EVENT_ACTIONS,
    EVENT_CATEGORIES,
    EVENT_TRACKER,
};
